import React from 'react';
import packageJson from '../../package.json';
import { motion } from 'framer-motion';
const { version } = packageJson;

const AboutScreen: React.FC = () => {
    return (
        <div className="min-h-screen bg-[#F8FAFC] font-sans selection:bg-purple-200 pb-28 pt-8 px-5 relative">
            {/* Animated Background Mesh */}
            <div className="fixed inset-0 z-0 overflow-hidden pointer-events-none">
                <div className="absolute top-[10%] left-[-20%] w-[60vw] h-[60vw] bg-teal-200 rounded-full  blur-3xl opacity-40 "></div>
                <div className="absolute top-[40%] right-[-20%] w-[50vw] h-[50vw] bg-purple-200 rounded-full  blur-3xl opacity-40  "></div>
                <div className="absolute bottom-[-10%] left-[10%] w-[70vw] h-[70vw] bg-pink-200 rounded-full  blur-3xl opacity-30  "></div>
                <div className="absolute inset-0 bg-white/40 backdrop-blur-[50px]"></div>
            </div>

            <div className="relative z-10 max-w-md mx-auto">
                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6 }}
                    className="flex flex-col items-center mb-10"
                >
                    <div className="w-32 h-32 rounded-[2rem] bg-white p-2 shadow-lg shadow-teal-500/20 mb-6 transform hover:scale-105 transition-transform duration-500">
                        <img src="/assets/images/logo_sikembang.png" alt="Si-Kembang Logo" className="w-full h-full object-cover rounded-3xl" />
                    </div>
                    <h1 className="text-3xl font-extrabold text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-purple-600 mb-2">si-kembang</h1>
                    <p className="text-gray-500 font-medium tracking-wide">Versi {version}</p>
                </motion.div>

                <motion.div 
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.6, delay: 0.2 }}
                    className="bg-white/60 backdrop-blur-2xl rounded-[1.5rem] p-6 sm:p-8 border border-white shadow-[0_8px_30px_rgba(0,0,0,0.04)] mb-8"
                >
                    <div className="flex items-center space-x-3 mb-4">
                        <div className="w-10 h-10 rounded-xl bg-purple-100 flex items-center justify-center text-xl shadow-sm border border-purple-200 text-purple-600">
                            ℹ️
                        </div>
                        <h2 className="text-xl font-bold text-gray-800">Tentang Aplikasi</h2>
                    </div>
                    <p className="text-gray-600 leading-relaxed text-sm">
                        Aplikasi ini dirancang untuk membantu orang tua, guru PAUD, dan tenaga kesehatan dalam melakukan skrining deteksi dini tumbuh kembang (SIKEMBANG) pada anak. Tujuannya adalah untuk memantau perkembangan anak secara rutin dan mendeteksi secara dini kemungkinan adanya penyimpangan agar dapat segera ditindaklanjuti.
                    </p>
                </motion.div>

                <motion.div 
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    transition={{ duration: 0.8, delay: 0.4 }}
                    className="text-center text-xs text-gray-400 font-medium"
                >
                    <p>&copy; {new Date().getFullYear()} Tim Pengembang. Hak Cipta Dilindungi.</p>
                    <p className="mt-1">Didanai oleh Hibah Kemenristekdikti</p>
                </motion.div>
            </div>

            <style>{`
                
                    33% { transform: translate(30px, -50px) scale(1.1); }
                    66% { transform: translate(-20px, 20px) scale(0.9); }
                    100% { transform: translate(0px, 0px) scale(1); }
                }
                . { animation: blob 15s infinite alternate ease-in-out; }
                . { animation-delay: 2s; }
                . { animation-delay: 4s; }
            `}</style>
        </div>
    );
};

export default AboutScreen;